export const BOOT_LOADER_SELECTOR = '[data-pexify-boot-loader]'
export const BOOT_LOADER_EXIT_MS = 100

const scheduledDismissals = new WeakSet<Element>()

export function dismissBootLoader(): void {
  const loader = document.querySelector(BOOT_LOADER_SELECTOR)

  if (!loader || scheduledDismissals.has(loader)) {
    return
  }

  scheduledDismissals.add(loader)
  loader.setAttribute('data-state', 'exiting')

  window.setTimeout(() => {
    loader.remove()
    scheduledDismissals.delete(loader)
  }, BOOT_LOADER_EXIT_MS)
}
